/**
 * The runtime SDK every published vibe page loads. Generated sites import @vibe/form, a thin proxy
 * that delegates here, so fixes reach published sites on next page load without a republish.
 */
import { submit } from './form';

const api = {
    form: { submit },
};

if (typeof window !== 'undefined') {
    // Merged, not replaced: the page shell writes window.vibe.config before this script loads, and
    // other capabilities install alongside form.
    window.vibe = { ...window.vibe, form: api.form };
}

export default api;
